const objectFitImages = require("object-fit-images");
import Components from "./Components/Components";
import MoveToController from "./Utils/MoveToController";
import MeshHelper from "mesh-helper";

class App {
	constructor() {
		objectFitImages(false, { watchMQ: false, skipTest: false });

		this.components = new Components();
		this.moveToController = new MoveToController();
		this.meshHelper = new MeshHelper({
			useCookie: false,
			isHidden: true,
		});
		window.scroll(0, 0);
	}
}

new App();



// WEBPACK FOOTER //
// ./App.js